import api from "../apis/AiPastSessionsApi";

const extractListAndPagination = (res) => {
  const body = res?.data;
  const inner = body?.data ?? body;
  const list = Array.isArray(inner)
    ? inner
    : inner?.result ?? inner?.sessions ?? inner?.batches ?? inner?.data ?? [];

  const nestedPagination =
    !Array.isArray(inner) && inner?.pagination ? inner.pagination : null;
  const topLevelPagination =
    typeof body?.total === "number" ||
    typeof body?.totalPages === "number" ||
    typeof body?.page === "number" ||
    typeof body?.limit === "number"
      ? {
          page: body?.page,
          limit: body?.limit,
          totalItems: body?.total,
          totalPages: body?.totalPages,
          hasNextPage: body?.hasNextPage,
          hasPrevPage: body?.hasPrevPage,
        }
      : null;

  const pagination = nestedPagination ?? topLevelPagination;
  return { list, pagination };
};

export const ListAiBatches =
  (data, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .batches(data)
      .then((res) => {
        const { list, pagination } = extractListAndPagination(res);
        onSuccess?.({ list, pagination });
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to fetch AI batches";
        onError?.(msg);
      });
  };

export const ListAiSessionsForAssign =
  (data, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .list(data)
      .then((res) => {
        const { list, pagination } = extractListAndPagination(res);
        onSuccess?.({ list, pagination });
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to fetch AI sessions";
        onError?.(msg);
      });
  };

export const AssignAiSessionsToBatch =
  (payload, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .assignToBatch(payload)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to assign AI sessions to batch";
        onError?.(msg);
      });
  };

export const ManualCreateAiBatch =
  (payload, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .manualCreateBatch(payload)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to create batch";
        onError?.(msg);
      });
  };

export const UpdateAiBatch =
  (id, payload, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .updateBatch(id, payload)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to update batch";
        onError?.(msg);
      });
  };

